import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  PARAMETER_VALUE,
  AND_TOGGLE,
} from "../../../../../constants/config/hash";
import {
  findHashValue,
  hashToValues,
  updateHash,
} from "../../../../../utilities/hash";
import ToggleCheckBox from "../ToggleCheckBox";

const AndOr = (props) => {
  const labels = useSelector((state) => state.labels.button),
    reset = useSelector((state) => state.filters.lastReset),
    [lastReset, setLastReset] = useState(undefined),
    [orAndToggle, setOrAndToggle] = useState(false);

  // update initial value
  useEffect(() => {
    let hash = findHashValue(PARAMETER_VALUE.replace("{id}", props.parameter)),
      andToggleHash = findHashValue(AND_TOGGLE);

    if (!hash) {
      setOrAndToggle(false);
    } else if (
      andToggleHash &&
      hashToValues(andToggleHash).includes(props.parameter)
    ) {
      setOrAndToggle(true);
    }
  }, []);

  // handle change
  useEffect(() => {
    const andToggleHash = findHashValue(AND_TOGGLE),
      andToggleHashValues = andToggleHash ? hashToValues(andToggleHash) : [],
      index = andToggleHashValues.indexOf(props.parameter);

    if (index === -1 && orAndToggle) {
      andToggleHashValues.push(props.parameter);
    } else if (index > -1 && !orAndToggle) {
      andToggleHashValues.splice(index, 1);
    }

    if (andToggleHashValues.length) {
      updateHash(AND_TOGGLE, `${AND_TOGGLE}=${andToggleHashValues.join("|")}`);
    } else {
      updateHash(AND_TOGGLE, null);
    }
    props.callback(orAndToggle);
  }, [orAndToggle]);

  // handle reset
  useEffect(() => {
    if (reset !== lastReset || props.resetSignal) {
      setLastReset(reset);
      setOrAndToggle(false);
      props.setResetSignal(false);
    }
  }, [reset, lastReset, setLastReset, props.resetSignal]);

  return (
    <div className="toggleSwitchContainer">
      <ToggleCheckBox
        checked={orAndToggle}
        id={`toggleCheck-${props.parameter}`}
        ariaLabel = {props.ariaLabel}
        onClick={() => setOrAndToggle(!orAndToggle)}
        {...props}
      />
    </div>
  );
};

AndOr.propTypes = {
  parameter: PropTypes.string.isRequired,
  callback: PropTypes.func,
  resetSignal: PropTypes.bool,
  setResetSignal: PropTypes.func,
};

export default AndOr;
